var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "8.4666mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 846.66 846.66",
    width: "8.4666mm",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .fil0 {fill:black;fill-rule:nonzero}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M31.26 117.39l784.14 0c11.39,0 20.64,9.24 20.64,20.64l0 570.6c0,11.4 -9.25,20.64 -20.64,20.64l-784.14 0c-11.39,0 -20.64,-9.24 -20.64,-20.64l0 -570.6c0,-11.4 9.25,-20.64 20.64,-20.64zm91.45 495.48c-27.15,0 -27.15,-41.28 0,-41.28l402.56 0c27.15,0 27.15,41.28 0,41.28l-402.56 0zm0 -91.89c-27.15,0 -27.15,-41.28 0,-41.28l325.55 0c27.15,0 27.15,41.28 0,41.28l-325.55 0zm0 -91.89c-27.15,0 -27.15,-41.28 0,-41.28l236.29 0c27.15,0 27.15,41.28 0,41.28l-236.29 0zm481.23 27.18l36.38 99.95c9.22,25.45 -29.48,39.48 -38.7,14.03l-36.36 -99.91c-6.31,1.07 -12.8,1.63 -19.41,1.63 -63.6,0 -115.16,-51.55 -115.16,-115.15 0,-4.26 0.24,-8.48 0.69,-12.62l-338.86 0c-11.39,0 -20.64,-9.24 -20.64,-20.64l0 -108.52c0,-11.39 9.25,-20.64 20.64,-20.64l484.84 0c11.39,0 20.64,9.25 20.64,20.64l0 39.08c38.58,19.63 63.01,59.19 63.01,102.7 0,41.1 -21.78,78.79 -57.07,99.45zm-159.88 -153.35c19.96,-37.62 58.99,-61.26 101.79,-61.26 3.66,0 7.29,0.18 10.87,0.51l0 -6.49 -443.56 0 0 67.24 330.9 0zm101.79 127.77c40.8,0 73.88,-33.07 73.88,-73.87 0,-40.68 -33.17,-73.88 -73.88,-73.88 -40.8,0 -73.88,33.08 -73.88,73.88 0,40.8 33.08,73.87 73.88,73.87zm248.91 -272.02l-742.86 0 0 529.32 742.86 0 0 -529.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.2cf96d4a69ac2f7fe969bbfe49f6f732.svg";
export { ForwardRef as ReactComponent };